<template>
  <client-only>
    <ProductListCarousel
      v-if="recentReviewData.products.length"
      :products="recentReviewData.products"
      :title="recentReviewData?.title"
      :statistic-item-list-name="pageData?.currentTranslation?.title || ''"
    />
  </client-only>
</template>

<script setup lang="ts">
import { BlockSliderContent, PageData } from "ecom-types";

const props = defineProps<{ data: BlockSliderContent; pageData?: PageData }>();

const { $api } = useNuxtApp();
const { updateRecentliView, recentlyViewed } = useRecentReview();

const recentReviewData = computed(() => {
  return {
    title: props?.data?.title ?? "",
    products: recentlyViewed.value,
  };
});

onMounted(async () => {
  await nextTick();
  await getRecentlyViewed();
});

async function getRecentlyViewed() {
  const ids = recentlyViewed.value.filter((el) => el.id).map((el) => el.id);

  try {
    const { data } = await $api.products.getCatalogNoRef(
      objectToQuery({ ids }),
    );
    const recently = recentlyViewed.value.reduce((acc, item) => {
      const existedProduct = data.find((el) => el.id === item.id);
      if (existedProduct) {
        acc.push({
          ...existedProduct,
          currentTranslation: {
            ...existedProduct.currentTranslation,
          },
          default_config: {
            ...existedProduct.default_config,
            materials: item.default_config?.materials || [],
          },
          variant_plp_image: {
            ...existedProduct.variant_plp_image,
            cost: item.variant_plp_image?.cost,
            image: item.variant_plp_image?.image,
            sku: item.variant_plp_image?.sku,
            currentTranslation: {
              ...existedProduct.variant_plp_image?.currentTranslation,
              title: item.variant_plp_image?.currentTranslation?.title,
              description:
                item.variant_plp_image?.currentTranslation?.description,
            },
          },
        });
      }
      return acc;
    }, [] as any[]);

    updateRecentliView(recently);
  } catch (error) {
    console.error(error);
  }
}
</script>
